import _ from "underscore";
import { setMockedDate, restoreMockedDate, isDateMocked } from "../../utils/debug/dateMock";
import storage from "../../utils/storage/storage";
import toastr from "../../utils/toastr";
import { dispatcher, DispatcherEvents } from "../../utils/dispatcher";
import { getCurrentVehicle } from "../../utils/device";
import { MobileActions } from "../../store/mobile/actions";
import DutyStatusLog from "../../model/DutyStatusLog";
import pageHTML from "./mocks.tmpl";
import { DataActions } from "../../store/data/actions";
import { getServerDate } from "../../utils/storage/date";
import { DAYS, MINUTES } from "../../constants";
import DebugPageView from "./debugPageView";
import type { THosStatus } from "hos-tools";

export default class MocksView extends DebugPageView {
    private readonly template = _.template(pageHTML);

    constructor(options) {
        super(options);
        this.storeUnsubscribe = this.app.observeStore(state => [state.data.clockDriftMs, state.data.lastLoginDate], this.render.bind(this));
    }

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            "click #overrides-dateshift-now": this.mockDateNow,
            "click #overrides-dateshift-wait": this.mockDateWait,
            "click #overrides-dateshift-restore": this.restoreDate,
            "click #exceed-storage-capacity": this.exceedStorageCapacity,
            "click #add-log": this.addInvalidLog,
            "click #sessionexpire-set": this.setSessionExpiryDate,
            "click #sessionexpire-force-check": this.checkSessionExpiry
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    render() {
        const [shouldExpireSession, expiryData] = this.app.sessionService["getEarlyExpiryInformation"]();
        const sessionExpiryData = {
            shouldExpireSession,
            ...expiryData
        };
        this.el.innerHTML = this.template({
            currentDate: new Date().toISOString(), // "new Date()" is allowed here
            isDateMocked: this.isDateMocked(),
            currentClockDrift: this.app.store.getState().data.clockDriftMs,
            sessionExpiryData
        });

        this.app.store.dispatch(MobileActions.setPageState({
            title: "Mocks",
            pageLevel: 2
        }));

        return this;
    }

    mockDateNow(): void {
        this.mockDate(true);
    }

    mockDateWait(): void {
        this.mockDate(false);
    }

    mockDate(syncNow: boolean): void {
        let dateInputElement = <HTMLInputElement>document.getElementById("overrides-dateshift");
        let timestamp = dateInputElement.value;

        setMockedDate(timestamp);

        if (syncNow) {
            void this.app.databaseCache.getClockDrift().then(driftMs => {
                toastr.success(`The browser clock is now set to: ${ new Date().toISOString() }`); // "new Date()" is allowed here
                let currentDriftElement = <HTMLInputElement>document.getElementById("overrides-dateshift-currentdrift");
                currentDriftElement.value = `${ driftMs }`;
            });
        }
    }

    restoreDate(): void {
        if (this.isDateMocked()) {
            restoreMockedDate();
            toastr.warning("The date was restored.");
        } else {
            toastr.warning("The date was not overridden, so no need to restore");
        }
    }

    isDateMocked(): boolean {
        return isDateMocked();
    }

    setSessionExpiryDate() {
        const currentUser = this.app.userService.getCurrentUser();
        if (!currentUser) {
            return;
        }
        const lastLoginDate = new Date(getServerDate().getTime() - (13 * DAYS) + MINUTES);
        this.app.store.dispatch(DataActions.setLastLoginDate({[currentUser.name]: lastLoginDate.toISOString()}));
    }

    checkSessionExpiry() {
        this.app.sessionService.checkExpiry();
        this.render();
    }

    exceedStorageCapacity(): void {
        let reallyLongString = new Array(10 * 1024 * 1024).join("*");
        storage.set("@logs", reallyLongString);
    }

    addInvalidLog(): void {
        let date = new Date().toISOString();
        let device = getCurrentVehicle();
        let statuses: THosStatus[] = ["Connected", "Disconnected", "Login", "Logoff"];
        let currentUser = this.app.userService.getCurrentUser();

        for (let i = 0; i < statuses.length; i++) {
            let newLog = new DutyStatusLog({
                dateTime: date,
                status: statuses[i],
                driver: currentUser ? { id: currentUser.id } : { id: "NoUserId" },
                device: device ? { id: device.id } : { id: "NoDeviceId" },
                coDrivers: [],
                origin: "Automatic",
                id: (`Automatic${ statuses[i] }${ date }`)
            });

            dispatcher.trigger(DispatcherEvents.UserAddDSLForDriver, newLog);
        }
    }
}